<script>
import {mapActions, mapGetters} from "vuex";
import AppLoading from "@/components/elements/AppLoading.vue";

export default {
  name: "AccidentIncidentYearlyReportGraph",
  data() {
    const months = Array.from({ length: 12 }, (_, i) =>
      new Intl.DateTimeFormat('en', { month: 'short' })
        .format(new Date(2025, i, 1))
        .toLowerCase()
    );

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => currentYear - 9 + i).reverse();

    return {
      months,
      years,
      currentYear,
      dataForTable : []
    }
  },
  components: {AppLoading},
  methods : {
    ...mapActions([
      'getDashboardAIYearlySummary'
    ]),
    async getData(data) {
      this.$store.commit('SET_ACCIDENT_INCIDENT_YEARLY_LOADING', true);
      data.loading = true;
      let params = {
        module : data.module,
        year : data.year
      };
      data.data = await this.getDashboardAIYearlySummary(params);
      data.loading = false;

      this.$store.commit('SET_ACCIDENT_INCIDENT_YEARLY_LOADING', false);
    },
    setupDataForTable() {
      for (let counter = 0; counter < this.features.length; counter++) {
        this.dataForTable.push({
          loading : true,
          module : this.features[counter],
          year : this.currentYear,
          data : []
        })
      }
    },
    async requestDataForTable() {
      for (let counter = 0; counter < this.dataForTable.length; counter++) {
        await this.getData(this.dataForTable[counter]);
      }
    }
  },
  async created() {
    this.setupDataForTable()
    await this.requestDataForTable();
  },
  computed: {
    ...mapGetters([
      'airYearlySummaryLoading',
      'airYearlySummaryData',
    ]),
    features() {
      if (this.$route.params.chart_module === 'safety_and_health') {
        return [
          'injuries',
          'illnesses'
        ]
      }

      return [
        this.$route.params.chart_module
      ]
    }
  }
}
</script>

<template>
  <div>
    <template v-for="feature in dataForTable">
      <div class="card shadow-sm rounded mb-4">
        <div class="card-body h-100">

          <div class="row no-gutters">
            <div class="col">
              <h5 class="e-text-red-light-1 text-uppercase" v-if="feature.module === 'injuries' || feature.module === 'illnesses'">YEARLY SUMMARY ({{ feature.module }})</h5>
              <h5 v-else class="e-text-red-light-1 text-uppercase">YEARLY SUMMARY</h5>
            </div>
            <div class="col-2 col-md-auto">
              <select class="float-right mb-1 form-control form-control-sm w-auto ml-3" v-model="feature.year" @change="getData(feature)" :disabled="feature.loading">
                <option :value="year" v-for="year in years">{{ year }}</option>
              </select>
            </div>
          </div>
          <div style="overflow-x: auto">
            <table class="table text-center table-bordered e-tbl" style="min-height: 645px">
              <thead class="bg-white">
              <tr>
                <th class="text-uppercase align-middle" colspan="3">
                  Number of Report
                </th>
                <th class="text-uppercase align-middle" v-for="month in months">
                  {{ month }}
                </th>
                <th class="text-uppercase align-middle">
                  Total
                </th>
              </tr>
              </thead>
              <tbody>
              <template v-if="feature.loading">
                <tr>
                  <td colspan="100%" class="align-middle">
                    <app-loading
                      :message="feature.module === 'injuries' || feature.module === 'illnesses' ? 'Fetching CMS Data and Yearly Summary, Please Wait...' : 'LOADING YEARLY SUMMARY, PLEASE WAIT...'"
                    />
                  </td>
                </tr>
              </template>
              <template v-else>
                <template v-for="management_office in feature?.data">
                  <template v-if="management_office.code === 'kobe'">
                    <template v-for="fleet in management_office.fleets">
                      <template v-for="(sub_fleet, sub_fleet_index) in fleet.sub_fleets">
                        <tr>
                          <th class="custom text-uppercase align-middle" v-if="sub_fleet_index === 0 && fleet.code === 'pcc'" :rowspan="management_office?.fleets?.flatMap(fleet => fleet.sub_fleets || []).length">{{ management_office.name }}</th>
                          <template v-if="sub_fleet.code === 'sub_total'">
                            <th class="text-uppercase align-middle custom" colspan="2">{{ fleet.name }}</th>
                          </template>
                          <template v-else>
                            <th class="text-uppercase align-middle" v-if="sub_fleet_index === 0" :rowspan="fleet.sub_fleets.length">{{ fleet.name }}</th>
                            <th class="text-uppercase align-middle">{{ sub_fleet.name }}</th>
                          </template>

                          <template v-for="summary in sub_fleet.monthly_summary">
                            <th class="custom align-middle" v-if="sub_fleet.code === 'sub_total'"> {{ summary.data }}</th>
                            <td v-else>
                              {{ summary?.display_data }}</td>
                          </template>
                          <th class="custom align-middle">{{ sub_fleet.total }}</th>
                        </tr>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <tr v-for="(fleet, fleet_index) in management_office.fleets">
                      <th v-if="management_office.code === 'company_total'" style="border: none"></th>
                      <template v-else>
                        <th class="custom text-uppercase align-middle" v-if="fleet_index === 0" :rowspan="management_office.fleets.length">{{ management_office.name }}</th>
                      </template>
                      <th :colspan="2" class="text-uppercase align-middle" :class="[fleet.code === 'sub_total' || fleet.code === 'fleet_total' ? 'custom' : '']">{{ fleet.name }}</th>
                      <template v-for="summary in fleet.monthly_summary">
                        <th class="custom align-middle" v-if="fleet.code === 'sub_total' || fleet.code === 'fleet_total'"> {{ summary.data }}</th>
                        <td class="align-middle" v-else> {{ summary?.display_data }}</td>
                      </template>
                      <th class="custom align-middle">{{ fleet.total }}</th>
                    </tr>
                  </template>

                </template>
              </template>


              </tbody>
            </table>
          </div>

        </div>
      </div>
    </template>
  </div>

</template>

<style scoped>
.e-tbl thead tr th, .e-tbl tbody tr th, .e-tbl tbody tr td{
  border: 1px solid #b1b1b1;
}
</style>
